import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setInitialStatus } from '@/logic/requestStatus/actions'
import { getRequest } from '@/logic/requestStatus/reducer'
import type { RootState } from '@/redux/interfaces'
import type { IStore } from '@/types/IStore'
import { EChoosingLocationRequestName } from '../../constants'
import type { ISavingAddressListenerProps } from './interfaces'

const mapState = (state: RootState) => {
  const request = getRequest(EChoosingLocationRequestName.SAVE)(state)

  const store = (request?.data as (IStore & { sourceFieldTag?: string; shouldSyncChosenAddress?: boolean }) | undefined) || undefined

  return {
    store,
    sourceField: store?.sourceFieldTag,
  }
}

//eslint-disable-next-line @typescript-eslint/no-explicit-any
function SavingAddressListener<FormValues = Record<string, any>>(props: PropsWithChildren<ISavingAddressListenerProps<FormValues>>) {
  const { form, shouldEditForm, fieldName } = props
  const { store, sourceField } = useSelector(mapState)
  const dispatch = useDispatch()

  const isConsignorRelatedSource = (value?: string) =>
    Boolean(value && (value.includes('consignor') || value.includes('consignee') || value.includes('__localDropdown')))

  useEffect(() => {
    if (store) {
      const hasExplicitSyncFlag = typeof store.shouldSyncChosenAddress === 'boolean'
      const shouldSkipDueToFlag = store.shouldSyncChosenAddress === false
      const shouldSkipDueToSource = !hasExplicitSyncFlag && isConsignorRelatedSource(sourceField)

      if (shouldEditForm && !shouldSkipDueToFlag && !shouldSkipDueToSource) {
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        form.change(fieldName, store.id as any)
      }

      dispatch(setInitialStatus({ name: EChoosingLocationRequestName.SAVE }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store?.id, shouldEditForm, fieldName, sourceField])

  return null
}

export default SavingAddressListener
